var ptBR = {
  locale: 'pt_BR',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    monthList: ['Jan', 'Fev', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    shortMonthList: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    dayList: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    shortDayList: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    shortestDayList: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
  },
  'dynamic-date': {
    day: 'Dia',
    week: 'Semana',
    month: 'Mês',
    quarter: 'Trimestre',
    year: 'Ano',
    before: 'Antes de ${value}${unit}'
  },
  'auto-complete.placeholder': 'Insira',
  'auto-complete.empty': 'Sem dados',
  'cascader.titles': ['Nível 1', 'Nível 2', 'Nível 3', 'Nível 4', 'Nível 5', 'Nível 6', 'Nível 7', 'Nível 8'],
  'cascader.empty': 'Sem dados',
  'cascader.search': 'Insira',
  'color.custom': 'Personalizar cor',
  'date.year': 'Ano ${year}',
  'date.month': 'Mês',
  'date.month-first': false,
  'date.week': 'Semana',
  'date-picker.apply': 'Aplicar',
  'date-picker.cancel': 'Cancelar',
  'date-picker.end': 'Hora do fim',
  'date-picker.invalid-range': 'O intervalo de tempo selecionado excede o intervalo selecionável. Selecione um válido.',
  'date-picker.placeholder': 'Selecionar data',
  'date-picker.start': 'Hora de início',
  'date-comparison.compare': 'Comparar',
  'date-comparison.compare-text': 'VS',
  'date-comparison.error-source': 'Selecione a hora de início para a comparação',
  'date-comparison.error-target': 'Selecione a hora final para a comparação',
  'date-comparison.mom': 'Comparado com o período de tempo anterior',
  'date-comparison.placeholder': 'Hora de início - Hora de fim',
  'date-comparison.yoy': 'Este período de tempo no ano passado',
  'date-time-picker.date': 'Selecionar data',
  'date-time-picker.end': 'Selecione a data e hora de término',
  'date-time-picker.now': 'Agora',
  'date-time-picker.ok': 'Confirmar',
  'date-time-picker.placeholder': 'Insira',
  'date-time-picker.start': 'Selecione a data e hora de início',
  'date-time-picker-panel.start': 'Data de início',
  'date-time-picker-panel.end': 'Data final',
  'date-time-picker.time': 'Selecionar hora',
  'dynamic-date.customize': 'Personalizar',
  'dynamic-date.date-preview': 'Pré-visualização da data',
  'dynamic-date.dynamic-date': 'Data dinâmica',
  'dynamic-date.fixed-date': 'Data fixa',
  'dynamic-date.interval': 'Intervalo',
  'empty.text': 'Sem dados',
  'image-view.next': 'Próximo',
  'image-view.prev': 'Anterior',
  'image-view.rotate': 'Girar',
  'image-view.zoom-in': 'Ampliar',
  'image-view.zoom-out': 'Reduzir o zoom',
  'image-view.zoom-to-fit': 'Ajustar',
  'image-view.zoom-to-origin': 'Origem',
  'input.placeholder': 'Insira',
  'list-viewer.empty': 'Sem dados',
  'modal.cancel': 'Cancelar',
  'modal.ok': 'Confirmar',
  'pager.jump': 'Redirecionar',
  'pager.page.placeholder': 'Iinsira',
  'pager.size': '${count} registros / página',
  'pager.total': '${total} registros no total',
  'popover.cancel': 'Cancelar',
  'popover.ok': 'Confirmar',
  'schedule.clear': 'Limpar',
  'schedule.selected': 'Hora selecionada',
  'schedule.separator': ',',
  'schedule.title': 'Data / Hora',
  'select.clear': 'Limpar',
  'select.empty': 'Sem dados',
  'select.placeholder': 'Selecione',
  'select.search.placeholder': 'Insira',
  'select.select-all': 'Selecionar tudo',
  'select.selected': 'Selecionado',
  'select.selected-count': '${count} itens selecionados',
  'table.emptyText': 'Sem dados',
  'table.filter.confirm': 'Confirmar',
  'table.filter.reset': 'Redefinir',
  'tabs.more': 'Mais',
  'textarea.placeholder': 'Insira',
  'time-picker.placeholder': 'Selecionar hora',
  'time-range-picker.placeholder': 'Hora de início - Hora de fim',
  'transfer.empty': 'Sem dados',
  'transfer.placeholder': 'Insira',
  'transfer.source': 'Lista de fontes',
  'transfer.target': 'Lista de alvos',
  'tree-select.empty': 'Sem dados',
  'tree-select.placeholder': 'Insira',
  'tree.empty': 'Sem dados',
  'upload.click': 'Clique para carregar',
  'upload.drop': 'Arraste arquivos aqui ou',
  'upload.error.overflow-count': 'Excedeu o número máximo de arquivos',
  table: {
    selectionMenu: {
      selectCurrent: 'Select Current',
      selectAll: 'Select All',
      unselectCurrent: 'Unselect Current',
      unselectAll: 'Unselect All'
    }
  }
};
export default ptBR;